import {BaseApiTemplateService, Core2Config} from '../../shared';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {WfIssueToIssueLinkContainerModel} from "../../../../../../models";

@Injectable({providedIn: 'root'})
export class WfIssueToIssueLinkService extends BaseApiTemplateService<WfIssueToIssueLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-to-issue-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-to-issue-links';
    this.httpClient = http;
  }
}
